
import React, { ReactNode, memo } from 'react';
import { TabsContent } from '@/components/ui/tabs';

interface PreRenderedTabContentProps {
  value: string;
  activeTab: string;
  children: ReactNode;
}

export const PreRenderedTabContent = memo(function PreRenderedTabContent({ 
  value, 
  activeTab, 
  children 
}: PreRenderedTabContentProps) {
  // Calculate whether this tab is currently active
  const isActive = activeTab === value;
  
  return (
    <TabsContent 
      value={value} 
      className="w-full h-full overflow-y-auto"
      style={{ 
        opacity: isActive ? 1 : 0,
        pointerEvents: isActive ? 'auto' : 'none',
        // Changed from display to visibility to maintain scroll position
        visibility: isActive ? 'visible' : 'hidden',
        position: 'relative', // Changed from absolute to relative
        top: 0,
        left: 0,
        height: 'auto', // Changed from 100% to auto
        minHeight: '600px', // Add minHeight for consistent sizing
        width: '100%',
        willChange: 'opacity',
        transform: 'translateZ(0)', // Force GPU acceleration
        transition: 'opacity 0.2s ease-in-out', // Smooth transition when switching tabs
      }}
    >
      {children}
    </TabsContent>
  );
});
